export class FederatedSource {
    sources;
    /**
     * If true try all sources, else stop after the first source return some
     * data. Works for properties and reverse properties.
     */
    exhaustive;
    constructor(sources, exhaustive) {
        this.sources = sources;
        this.exhaustive = exhaustive;
    }
    static create(sources) {
        return new FederatedSource(sources, false);
    }
    static createExhaustive(sources) {
        return new FederatedSource(sources, true);
    }
    async property(iri, predicate) {
        const result = [];
        for (const source of this.sources) {
            addValues(result, await source.property(iri, predicate));
            if (!this.exhaustive && result.length > 0) {
                break;
            }
        }
        return Promise.resolve(result);
    }
    async reverseProperty(predicate, iri) {
        const result = [];
        for (const source of this.sources) {
            addValues(result, await source.reverseProperty(predicate, iri));
            if (!this.exhaustive && result.length > 0) {
                break;
            }
        }
        return Promise.resolve(result);
    }
}
function addValues(values, newValues) {
    // TODO Here we may consider to keep only unique values.
    values.push(...newValues);
}
//# sourceMappingURL=federated-rdf-source.js.map